import React, { useState } from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import CMSText from '../Global/CMSText'
import {
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
  withStyles,
} from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabContainer: {
      margin: theme.spacing(2, 0, 2),
    },
    rentAndSecondHandTabs: {},
    rentAndSecondHandTab: {
      minWidth: 0,
    },
  })
)

const MainTooltip = withStyles((theme) => ({
  tooltip: {
    textAlign: 'center',
    fontSize: 11,
    padding: theme.spacing(1),
    lineHeight: 1,
    '&:hover, &:focus': {
      cursor: 'default',
    },
    marginBottom: -theme.spacing(1),
  },
}))(Tooltip)

type Tprops = {
  selectedTakeBackOrRental: number
  handleTakeBackAndRental: (event: React.ChangeEvent, newValue: number) => any
  takeback: any
  t: any
  typeInCart: string | null
}

const TakeBackAndRentTab = ({
  selectedTakeBackOrRental,
  handleTakeBackAndRental,
  takeback,
  t,
  typeInCart,
}: Tprops) => {
  const tabClasses = useStyles()
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div
      className={tabClasses.tabContainer}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Tabs
        value={selectedTakeBackOrRental}
        onChange={handleTakeBackAndRental}
        scrollButtons={'auto'}
        className={tabClasses.rentAndSecondHandTabs}
      >
        <MainTooltip
          placement={'top'}
          open={showTooltip && typeInCart === 'SECOND_HAND'}
          title={
            <CMSText
              data={takeback?.data?.prevent_adding_differents_types_to_cart}
              defaultText={t(
                'texts:takeBack:prevent_adding_differents_types_to_cart'
              )}
            />
          }
          arrow
          enterDelay={2000}
        >
          <Tab
            label={
              <CMSText
                asText
                data={takeback?.data?.tab_label_rental}
                defaultText={t('texts:takeBack:tab_label_rental')}
              />
            }
            className={tabClasses.rentAndSecondHandTab}
            value={0}
            disabled={typeInCart === 'SECOND_HAND'}
          />
        </MainTooltip>
        <MainTooltip
          placement={'top'}
          open={showTooltip && typeInCart === 'RENTAL'}
          title={
            <CMSText
              data={takeback?.data?.prevent_adding_differents_types_to_cart}
              defaultText={t(
                'texts:takeBack:prevent_adding_differents_types_to_cart'
              )}
            />
          }
          arrow
          enterDelay={2000}
        >
          <Tab
            label={
              <CMSText
                asText
                data={takeback?.data?.tab_label_secondhand}
                defaultText={t('texts:takeBack:tab_label_secondhand')}
              />
            }
            value={1}
            disabled={typeInCart === 'RENTAL'}
          />
        </MainTooltip>
      </Tabs>
    </div>
  )
}

export default TakeBackAndRentTab
